var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Conversations")]),_vm._l((_vm.userData.conversations),function(conversation){return _c('ConversationListItem',{key:conversation.id,attrs:{"conversation":conversation}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }